module.exports = __webpack_public_path__ + "img/thumb_22.0071513d.jpg";